export default __webpack_public_path__ + "static/support2-16b301d4e5adc7c4eb425d34d6e7399d.webp";